module.exports = __webpack_public_path__ + "static/tarrasque-6e03e246b6e8e1a12c3e8bb3a200b420.jpg";